(() => {
  const loaderKey = '__jrjYouTubeIframeApi20260917';
  function loadApi() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve(window.YT);
    if (window[loaderKey]) return window[loaderKey];
    window[loaderKey] = new Promise(resolve => {
      let settled = false;
      const finish = () => {
        if (!settled && window.YT && typeof window.YT.Player === 'function') {
          settled = true;
          resolve(window.YT);
        }
      };
      const awaitReady = () => {
        if (window.YT && typeof window.YT.ready === 'function') window.YT.ready(finish);
        finish();
      };
      const previous = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function (...args) {
        try {
          if (typeof previous === 'function') previous.apply(this, args);
        } finally {
          finish();
        }
      };
      const existing = [...document.scripts].find(script => /^https:\/\/(?:www\.)?youtube\.com\/(?:iframe_api|player_api)(?:[?#]|$)/.test(script.src));
      if (existing) {
        existing.addEventListener('load', awaitReady, { once: true });
      } else {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        script.addEventListener('load', awaitReady, { once: true });
        document.head.append(script);
      }
      awaitReady();
    });
    return window[loaderKey];
  }

  function initialize(frame) {
    if (frame.dataset.jrjVideoInitialized === 'true') return;
    let activeIframe = frame.querySelector('[data-jrj-video-iframe]');
    const poster = frame.querySelector('[data-jrj-video-poster]');
    const retry = frame.closest('figure').querySelector('[data-jrj-video-retry]');
    const help = frame.closest('figure').querySelector('[data-jrj-video-help]');
    const videoId = frame.dataset.videoId;
    if (!activeIframe || !poster || !retry || !/^[\w-]{11}$/.test(videoId || '')) return;
    frame.dataset.jrjVideoInitialized = 'true';
    const iframeTemplate = activeIframe.cloneNode(false);
    let attempt = 0;
    let player = null;
    function play() {
      if (!/^https?:$/.test(window.location.protocol)) return;
      const currentAttempt = ++attempt;
      if (player) {
        try { player.destroy(); } catch (error) {}
        player = null;
      }
      activeIframe.remove();
      const iframe = iframeTemplate.cloneNode(false);
      const url = new URL('https://www.youtube-nocookie.com/embed/' + videoId);
      url.searchParams.set('enablejsapi', '1');
      url.searchParams.set('origin', window.location.origin);
      url.searchParams.set('playsinline', '1');
      url.searchParams.set('controls', '1');
      url.searchParams.set('rel', '0');
      url.searchParams.set('autoplay', '1');
      iframe.src = url.href;
      iframe.hidden = false;
      activeIframe = iframe;
      poster.hidden = true;
      retry.hidden = false;
      if (help) help.hidden = false;
      frame.dataset.videoState = 'loading';
      delete frame.dataset.videoError;
      frame.append(iframe);
      iframe.focus();
      const isCurrent = () => currentAttempt === attempt && activeIframe === iframe && frame.isConnected;
      loadApi().then(YT => {
        if (!isCurrent()) return;
        try {
          player = new YT.Player(iframe, {
            events: {
              onReady() {
                if (isCurrent() && frame.dataset.videoState === 'loading') frame.dataset.videoState = 'ready';
              },
              onError(event) {
                if (!isCurrent()) return;
                frame.dataset.videoState = 'error';
                frame.dataset.videoError = String(event.data);
              }
            }
          });
          frame.jrjVideoPlayer = player;
        } catch (error) {
          if (isCurrent()) frame.dataset.videoApi = 'unavailable';
        }
      });
    }
    poster.addEventListener('click', play);
    retry.addEventListener('click', play);
  }

  document.querySelectorAll('[data-jrj-video-player]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-jrj-video-player]').forEach(initialize));
})();
